function InfoItem({ title, value }) {
    return (
        <div className="flex-row align-space-between position-middle o-hide">
            <span>{title}</span>
            <span>{value}</span>
        </div>
    );
}
export default InfoItem;
